import { useQuery } from "@tanstack/react-query";
import { getAllEvents } from "../services/eventsServices";

export const useEvents = ({
  status,
  page = 1, // Changed from lastId/lastDate to page
  approvalStatus,
  category,
  homepage,
  enabled = true,
}) => {
  return useQuery({
    queryKey: ["events", status, page, approvalStatus, category, homepage],
    queryFn: () =>
      getAllEvents({
        status,
        page,
        approvalStatus,
        category,
        homepage,
      }),
    enabled,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};
